import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';
import color from 'utils/colors';

function ResetPasswordDialog({ open, onClose, user, onConfirm }) {
  if (!user) return null;

  // Get the display name (names and surnames if available, otherwise name)
  const displayName = user.names && user.surnames 
    ? `${user.names} ${user.surnames}`.trim()
    : user.names 
      ? user.names
      : user.name || 'Usuario';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Typography 
          variant="h6" 
          sx={{ 
            color: color.purpleSecondary,
            fontWeight: 'bold'
          }}
        >
          Restablecer Contraseña
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          ¿Estás seguro de que quieres resetear la contraseña de <strong>{displayName}</strong>?
        </Typography>
        
        <Typography variant="body1">
          Le llegará un correo a <strong>{user.email}</strong> para que pueda restablecerla.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', px: 3, pb: 3 }}>
        <Button 
          onClick={onClose}
          variant="outlined"
          sx={{
            borderColor: color.purpleSecondary,
            color: color.purpleSecondary,
            '&:hover': {
              borderColor: color.purpleSecondary,
              backgroundColor: `${color.purpleSecondary}10`,
            }
          }}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          onClick={() => onConfirm(user)}
          sx={{
            backgroundColor: color.purpleSecondary,
            '&:hover': {
              backgroundColor: color.purpleSecondary,
            }
          }}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ResetPasswordDialog;